module.exports = __webpack_public_path__ + "static/media/halodoc.1b990e00.webp";